import dateformat from "dateformat";
import { setter, getter } from '../utils/storage';
import { pushSearchesToApi } from '@growth/recent-search/helper';
import addDays from "../../../utils/date-utils/addDays";
import { AVAILABLE_CAB_TITLE, rental, AT_FAQ, DEFAULT_FAQ, HR_FAQ, HR_PACKAGE_IDS, ONE_WAY_CAB_FAQ } from "./constants";
import { AIRPORT_CAB, ROUND_TRIP_OUTSTATION_CAB, OUTSTATION_CAB, RENTAL_CAB, LOBNAME, LISTINGPAGE, COUNTRYCODE, COUNTRYNAME, TIMEZONE, ROUND_TRIP, rcDateTypeFormat, rcTimeTypeFormat, LOBCATEGORY, SEARCH_CONTEXT_LOB, LOCUS_DEFAULT_CITY_TYPE, AIRPORT_CABS, AIRPORT, ONE_WAY, OUTSTATION_ONE_WAY, OUTSTATION_ROUND_TRIP, LOCAL_RENTAL, Rental, OUTSTATTION_MULTICITY, SELF_DRIVE, SELFDRIVE } from "../utils/util-constants";
import { createUnificationRedirectUrl } from "../utils/redirect-utils";

export const getGeoLocation = (onsuccess) => {
  function onerror() {
    alert("Please allow location permission");
  }
  if (navigator?.geolocation) {
    navigator?.geolocation?.getCurrentPosition(onsuccess, onerror);
  } else {
    alert("Geo location is not supported on this browser");
  }
};

export const recentSearchStore = ({ source, destination, startDate, endDate, triptype, package_id = '' }) => {
  if (!Object.keys(source).length || !Object.keys(destination).length) return;
  const recenSearchResp = getter('CABS_RECENT_SEARCH') || { ow: [], at: [], hr: [] };
  const type = triptype?.rf === 'rt' ? 'ow' : triptype?.rf;
  const data = recenSearchResp[type] || [];
  let found = null;
   data?.forEach((item, index) => {
     if (item?.source?.place_id === source?.place_id && item?.destination?.place_id === destination?.place_id) {
      found = index;
    }
   });
  if (found !== null) {
    data.splice(found, 1);
  }
  const newData = {
    startDate: {
      ...startDate,
      date: dateformat(startDate.date, 'yyyy-mm-dd'),
    },
    endDate: {
      ...endDate,
      date: dateformat(endDate.date, 'yyyy-mm-dd'),
    }
  }

  if (type === 'hr') {
    newData['package_id'] = package_id
  }

  data.unshift({ source, destination, triptype, ...newData });
  if (!recenSearchResp[type]) {
    recenSearchResp[type] = data
  }
  setter('CABS_RECENT_SEARCH', recenSearchResp);
}

export const getRecentSearches = ({type = 'ow'}) => {
  const recentSearch = getter('CABS_RECENT_SEARCH') || { ow: [], at: [], hr: [] };
  const newType = type === 'rt' ? 'ow' : type;
  const data = recentSearch[newType] || [];
  return data;
}

export function generateTimeList(customHour = 0, customMinute = 0) {
  const timeList = [];
  const minuteCharList = ['00', '15', '30', '45'];
  let minutesLeft = 0;
  if (customMinute === 15) {
    minutesLeft = 1;
  } else if (customMinute === 30) {
    minutesLeft = 2;
  } else if (customMinute === 45) {
    minutesLeft = 3;
  }
  for (let i = customHour; i < 24; i += 1) {
    let hourChar = i;
    if (i > 12) {
      hourChar -= 12;
    }
    if (hourChar >= 0 && hourChar < 10) {
      hourChar = `0${hourChar}`;
    }
    for (let j = minutesLeft; j < 4; j++) {
      if (parseInt(hourChar, 10) > 9) {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      } else {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      }
    }
    minutesLeft = 0;
  }
  return timeList;
};

export function getDateForHome(daysOffset = 0) {
  const reqDate = addDays(new Date(), daysOffset);
  return new Date(
    `${dateformat(reqDate, "yyyy-mm-dd")}T10:00` // Fixing Date -> Date+1 and Time -> 10 AM
  );
}

export const isToday = (someDate) => {
  const today = new Date();
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
}

export const checkIfServer = () => typeof window === 'undefined';

export const convertTo24HourTimeFormat = (value: string) => {
  const amOrPm = value?.substring(6, value.length);
  if (amOrPm.includes('PM')) {
    const hourHand = value?.substring(0, 2);
    const minuteHand = value?.substring(3, 5);
    let val = '';
    if (parseInt(hourHand, 10) < 12) {
      val = parseInt(hourHand, 10) + 12;
      value = val + ':' + minuteHand + ' PM';
    }
  }
  return value;
};
export const parseForReviewTimeField = (value: string): string => {
  const val = convertTo24HourTimeFormat(value);
  const isAM = val.split(' ')[1];
  const time = val.split(' ')[0];
  if (isAM === 'AM') {
    if (time.length < 8) {
      return val.replace(' AM', ':00');
    }
    return time;
  }
  if (time.length < 8) {
    return val.replace(' PM', ':00');
  }
  return time;
};

export const getUrlParams = (url: string) =>
  `${url}?`
  .split('?')[1]
  .split('&')
  .reduce(
    (params, pair) =>
      ((key, val) => (key ? {...params, [key]: val} : params))(
        ...`${pair}=`.split('=').map(decodeURIComponent),
      ),
    {},
  );


export function scrollToTop(topPos = 0, smoothBehavior = true) {
  if (window)
    window.scrollTo({
      top: topPos,
      behavior: (smoothBehavior && 'smooth') || 'auto',
    });
}
  
export const formValidator = ({value, type}) => {
  let regex;
  switch (type) {
    // this regex allows all characters.
    case 'first_name':
      regex = /^[a-zA-Z '~!]{3,}$/;
      // [a-zA-Z0-9 '~!] => characters we want to match (customize as required)
      // {1,} match minimum 1 and maximum any number of characters from the previously defined class
      // $ end of the string
      break;
    case 'phone_number':
    case 'companyPhone':
    case 'gstPhoneNumber':
      // check for international
      regex = /^\d{10}$/;
      break;
    case 'email':
      regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      break;

    default:
      return false;
  }

  return regex.test(value);
};

export function signIn() {
  document.querySelector('#get_sign_in').click();
}
export function signUp() {
  document.querySelector('#get_sign_up').click();
}

export const commaSeperatedRupees = (data) => {
  if (data) {
    return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return data;
}


export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return '';
}

export function getAbsValue(value: number) {
  if (value) {
    return Math.abs(value);
  }
  return 0;
}

export const timeAMPMToTime = (date, time: string): Date => {
  const newTime = time.split(" ")[0].split(':');
  let newDate = new Date(date);
  if (time.includes('AM')) {
    newDate.setHours(parseInt(newTime[0], 10));
    newDate.setMinutes(parseInt(newTime[1], 10));
  } else {
    if ((parseInt(newTime[0], 10) + 12) === 23) {
      newDate = addDays(newDate, 1);
      return newDate;
    }
    newDate.setHours(parseInt(newTime[0], 10) + 12);
    newDate.setMinutes(parseInt(newTime[1], 10));
  }
  return newDate;
}

export const formatTime12Hour = (date: Date): string => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; 
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${minutesStr} ${ampm}`;
};

export const updateDateWithTime = (date, timeString) => {
  const newDate = new Date(date);

  const timeIn24HourFormat = convert12To24Format(timeString);
  const [hour, minute] = timeIn24HourFormat.split(':').map(Number);

  // Update the date object with the new time
  newDate.setHours(hour);
  newDate.setMinutes(minute);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
};


export const timeDiff = (date1, date2) => {
  const diff = date2.getTime() - date1.getTime();
  let msec = diff;
  const hh = Math.floor(msec / 1000 / 60 / 60);
  msec -= hh * 1000 * 60 * 60;
  const mm = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;
  const ss = Math.floor(msec / 1000);
  msec -= ss * 1000;
  return `${hh}:${mm}:${ss}`;
}

export const convert12To24Format = (time: string) => {
  let hours = Number(time.match(/^(\d+)/)[1]);
  const minutes = Number(time.match(/:(\d+)/)[1]);
  const AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM == "PM" && hours < 12) hours = hours+12;
  if (AMPM == "AM" && hours === 12) hours = hours-12;
  let sHours = hours.toString();
  let sMinutes = minutes.toString();
  if (hours < 10) sHours = "0" + sHours;
  if (minutes < 10) sMinutes = "0" + sMinutes;
  return `${sHours}:${sMinutes}`;
}



export const getTodaysDate = (min_offset = 15) => {
  let defaultDate = new Date();
  defaultDate.setMinutes(defaultDate.getMinutes() + min_offset);
  //Rounding off to the next multiple of 15
  if (defaultDate.getMinutes() >= 0 && defaultDate.getMinutes() < 15) {
    defaultDate.setHours(defaultDate.getHours(), 15, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() >= 15 && defaultDate.getMinutes() < 30) {
    defaultDate.setHours(defaultDate.getHours(), 30, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() >= 30 && defaultDate.getMinutes() < 45) {
    defaultDate.setHours(defaultDate.getHours(), 45, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  } else if (defaultDate.getMinutes() > 45) {
    defaultDate.setHours(defaultDate.getHours() + 1, 0, defaultDate.getSeconds(), defaultDate.getMilliseconds());
  }
  return defaultDate;
};

export function newTimeList(customHour = 0, customMinute = 0) {
  let hour = customHour === 24 ? 0 : customHour;
  const timeList = [];
  const minuteCharList = ['00', '15', '30', '45'];
  let minutesLeft = 0;
  if (customMinute > 0 && customMinute <= 15) {
    minutesLeft = 1;
  } else if (customMinute>15 && customMinute <=30) {
    minutesLeft = 2;
  } else if (customMinute >30 && customMinute <= 45) {
    minutesLeft = 3;
  }
  if (customMinute > 45) {
    hour = hour + 1;
  }
  for (let i = hour; i < 24; i += 1) {
    let hourChar = i;
    if (i > 12) {
      hourChar -= 12;
    }
    if (hourChar >= 0 && hourChar < 10) {
      hourChar = `0${hourChar}`;
    }
    for (let j = minutesLeft; j < 4; j++) {
      if (parseInt(hourChar, 10) > 9) {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      } else {
        timeList.push(`${hourChar}:${minuteCharList[j]} ${i < 12 ? 'AM' : 'PM'}`);
      }
    }
    minutesLeft = 0;
  }
  return timeList;
};

export const convert24To12Format = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours === 12 ? 12 : hours % 12;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return strTime;
}

export const replaceSRPUrlState = (store) => {
  const { common = {}, seoPage = {} } = store.getState();
  const { source = {}, startDate = {}, endDate = {}, tripType = {} , destination = {}, isSeo = false, package_id = '', source_locus = {}, destination_locus = {}, flow="", stopOvers = [], isUnificationFlow } = common;
  const { date: sd = new Date(), time: sTime = '' } = startDate;
  const { date: ed = new Date(), time: eTime = '' } = endDate;
  const { rf = '', name: tname = '' } = tripType;
  const { name = '', place_id = '', city_name = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = source;
  const { name: dname = '', place_id: dplace_id = '', city_name: dcity_name = '', address: daddress = '', latitude: dlatitude = '', longitude: dlongitude = '', pincode: dpincode = '', google_city: dgoogle_city = '', is_city: dis_city = false, is_airport: dis_airport = false } = destination;
  const startTime = convertTo24HourTimeFormat(sTime);
  const endTime = convertTo24HourTimeFormat(eTime);
  
  if (isUnificationFlow) {
    const redirectUrl = createUnificationRedirectUrl({
      source,
      destination,
      startDate,
      endDate,
      rf: tripType?.rf,
      package_id,
      stopOvers
    })
    window.location.href = redirectUrl;
    return;
  }
  const postData = {
    s_n: name,
    s_i: place_id,
    d_n: dname,
    d_i: dplace_id,
    s_c: city_name,
    s_a: address,
    d_a: daddress,
    s_lat: latitude,
    s_long: longitude,
    d_lat: dlatitude,
    d_long: dlongitude,
    s_pin: pincode,
    d_pin: dpincode,
    s_gc: google_city,
    d_gc: dgoogle_city,
    s_is_city: is_city,
    d_is_city: dis_city,
    s_is_airport: is_airport,
    d_is_airport: dis_airport,
    s_t: `${dateformat(sd, 'yyyy-mm-dd')}T${startTime.split(' ')[0]}`,
    e_t: rf === "rt" ? `${dateformat(ed, 'yyyy-mm-dd')}T${endTime.split(' ')[0]}` : "",
    t_t: tname,
    fl: 'cars_dweb',
    rf,
    s_l: source_locus,
    d_c: dcity_name,
    d_l: destination_locus,
    off: '',
    r_off: '',
    isSeo: !!isSeo,
    flow
  };

  //added package_id in url for hr on page load
  if (tripType?.rf === 'hr') {
    postData['d_n'] = '',
    postData['d_i'] = '',
    postData['d_c'] = '',
    postData['d_a'] = '',
    postData['d_lat'] = '',
    postData['d_long'] = '',
    postData['d_pin'] = '',
    postData['d_gc'] = '',
    postData['d_is_city'] = false,
    postData['d_is_airport'] = false,
    postData['d_l'] = '',
    postData['package_id'] = package_id
  }

  if (stopOvers.length && rf !== 'hr' && rf !== 'at') {
    const newStopOvers = stopOvers.map(details => {
      const { name = '', place_id = '', city_name = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = details?.value || {};
      return {
        id: details?.id,
        value: {
          place_id,
          region: city_name,
          description: name,
          address,
          latitude,
          longitude,
          pincode,
          google_city,
          is_city,
          is_airport
        }
      }
    })
    postData['stops'] = newStopOvers
  }

  const { filters = {} } = seoPage;
  let url = `/cars/review/?qryParams=${JSON.stringify(postData)}`;
  if (filters && isSeo && Object.keys(filters)?.length > 0) {
    url = `${url}&filters=${JSON.stringify(filters)}`;
  }
  try{
    window.history.replaceState(null, "", url);

  }catch(err){
    console.log(err);
  }
}

export const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const getCrouselDataInFormat = (item) => {
  const { package_id, pkg_id, name, time, distance, price, min_fare } = item
  return {
    package_id: package_id || pkg_id,
    name,
    time,
    distance,
    min_fare: price ? `₹ ${price}` : min_fare
  }
}

export const getTitleForAvailableCabs = (pageType='', source={}, destination={}) => {
  if(pageType===rental){
      return `${AVAILABLE_CAB_TITLE?.rental}${source?.name}`
  }else if(pageType){
      return `${AVAILABLE_CAB_TITLE?.pageType}${source?.name} to ${destination?.name} Cab`
  }
  return `${AVAILABLE_CAB_TITLE?.other}${source?.name} to ${destination?.name}`
}

export const getSubLobName = (tripTypeRf) => {
  switch(tripTypeRf) {
    case 'hr': return RENTAL_CAB
    case 'rt': return ROUND_TRIP_OUTSTATION_CAB
    case 'at': return AIRPORT_CAB
    default: return OUTSTATION_CAB;
  }
}

export const preparePageUrl = (pageName:string, urlParams={}, urlFilters={}) => {
  switch(pageName){
    case 'SRP': {
      let url = `${__ENV_CONFIG__['__GOIBIBO__']}/cars/review/?qryParams=${JSON.stringify(urlParams)}`;
      if (urlFilters && Object.keys(urlFilters)?.length > 0) {
        url = `${url}&filters=${JSON.stringify(urlFilters)}`;
      }
      return url
    }
    default: {
      return `${__ENV_CONFIG__['__GOIBIBO__']}/cars`
    }
  }
}

const getTripTypeInfoForGoData = (tripType) => {
  switch (tripType) {
    case AIRPORT_CABS:
      return AIRPORT
    case ONE_WAY:
      return OUTSTATION_ONE_WAY
    case ROUND_TRIP:
      return OUTSTATION_ROUND_TRIP
    case SELF_DRIVE:
      return SELFDRIVE
    case LOCAL_RENTAL:
      return Rental
    case OUTSTATTION_MULTICITY:
      return OUTSTATTION_MULTICITY
    default:
      return tripType
  }
}

const getGoDataNDeepLink = (requiredData) => {
  const { startDate, endDate, triptype, source, destination, isSeo, hrSelectedPackageId, seoSelectedFilters, sourceLocusDetails = {}, destinationLocusDetails = {}, stopOvers = [] } = requiredData
  const { date: sd = new Date(), time: sTime = '' } = startDate;
  const { date: ed = new Date(), time: eTime = '' } = endDate;
  const { rf = '', name: tname = '' } = triptype;
  const { name = '', place_id = '', city_name = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = source;
  const { name: dname = '', place_id: dplace_id = '', city_name: dcity_name = '', address: daddress = '', latitude: dlatitude = '', longitude: dlongitude = '', pincode: dpincode = '', google_city: dgoogle_city = '', is_city: dis_city = false, is_airport: dis_airport = false } = destination;
  const startTime = convertTo24HourTimeFormat(sTime);
  const endTime = convertTo24HourTimeFormat(eTime);
  const postData = {
    s_n: name,
    s_i: place_id,
    d_n: dname,
    d_i: dplace_id,
    s_c: city_name,
    s_a: address,
    d_a: daddress,
    s_lat: latitude,
    s_long: longitude,
    d_lat: dlatitude,
    d_long: dlongitude,
    s_pin: pincode,
    d_pin: dpincode,
    s_gc: google_city,
    d_gc: dgoogle_city,
    s_is_city: is_city,
    d_is_city: dis_city,
    s_is_airport: is_airport,
    d_is_airport: dis_airport,
    s_t: `${dateformat(sd, 'yyyy-mm-dd')}T${startTime.split(' ')[0]}`,
    e_t: rf === "rt" ? `${dateformat(ed, 'yyyy-mm-dd')}T${endTime.split(' ')[0]}` : "",
    t_t: tname,
    fl: 'cars_dweb',
    rf,
    d_c: dcity_name,
    s_l: sourceLocusDetails,
    d_l: destinationLocusDetails,
    off: '',
    r_off: '',
    isSeo: !!(isSeo)
  };
  const goData = {
    d: dateformat(sd, 'yyyy-mm-dd'),
    time: `${startTime.split(' ')[0]}:00`,
    rd: rf === "rt" ? dateformat(ed, 'yyyy-mm-dd') : "",
    rtime: rf === "rt" ? `${endTime.split(' ')[0]}:00` : "",
    trip_type: getTripTypeInfoForGoData(tname),
    sn: name,
    s_c: city_name,
    s_a: address,
    d_a: daddress,
    s_lat: latitude,
    s_long: longitude,
    d_lat: dlatitude,
    d_long: dlongitude,
    s_pin: pincode,
    d_pin: dpincode,
    s_gc: google_city,
    d_gc: dgoogle_city,
    s_is_city: is_city,
    d_is_city: dis_city,
    s_is_airport: is_airport,
    d_is_airport: dis_airport,
    s_l: sourceLocusDetails,
    sid: place_id,
    dn: dname,
    did: dplace_id,
    d_c: dcity_name,
    d_l: destinationLocusDetails,
    pc: '',
    flow: getTripTypeInfoForGoData(tname),
  }
  if (triptype?.rf === 'hr') {
    postData['d_n'] = ''
    postData['d_i'] = ''
    postData['d_c'] = ''
    postData['d_a'] = ''
    postData['d_lat'] = ''
    postData['d_long'] = ''
    postData['d_pin'] = ''
    postData['d_gc'] = ''
    postData['d_is_city'] = false
    postData['d_is_airport'] = false
    postData['d_l'] = {}
    postData['package_id'] = hrSelectedPackageId
    goData['rental_package'] = hrSelectedPackageId
  }

  if (stopOvers.length && rf !== 'hr' && rf !== 'at') {
    const newStopOvers = stopOvers.map(details => {
      const { name = '', place_id = '', city_name = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = details?.value || {};
      return {
        id: details?.id,
        value: {
          place_id,
          region: city_name,
          description: name,
          address,
          latitude,
          longitude,
          pincode,
          google_city,
          is_city,
          is_airport
        }
      }
    })
    postData['stops'] = newStopOvers
  }

  return {
    deepLink: preparePageUrl(LISTINGPAGE, postData, seoSelectedFilters),
    goData: JSON.stringify(goData)
  }
}

export const pushDataToCommonRecentSearch = (requiredData) => {
  const { startDate, endDate, triptype, source, destination, sourceLocusDetails = {}, destinationLocusDetails = {} } = requiredData
  const { name:sCityName, place_id:sPlaceId, city_name:sCityRegion, lobCity:sLobCity = '' } = source
  const { name:dCityName, place_id:dPlaceId, city_name:dCityRegion, lobCity:dLobCity = '' } = destination
  const { city:locusSourceCity = '', type:locusSourceType = LOCUS_DEFAULT_CITY_TYPE, name:locusSourceName = '', country:locusSourceCountry = COUNTRYCODE } = sourceLocusDetails
  const { city:locusDestinationCity = '', type:locusDestinationType = LOCUS_DEFAULT_CITY_TYPE, name:locusDestinationName = '', country:locusDestinationCountry = COUNTRYCODE } = destinationLocusDetails
  const searchDetails = {
    searchContext: {
      from: {
        placeId: sPlaceId,
        countryCode: COUNTRYCODE,
        lobCountry: COUNTRYNAME,
        lobCity: sCityRegion ? sCityRegion : '',
        cityName: sCityName,
        locus: {
          city: locusSourceCity,   // this will be locusCityCode
          type: locusSourceType,
          name: locusSourceName,
          country: locusSourceCountry
        }
        // lng: null, // not sending as of now bcz we don't have lat lng
        // lat: null,
      },
      fromDateTime: {
        ts: new Date(startDate?.date).getTime(),
        zone: TIMEZONE,
        timezone: TIMEZONE,
        str: `${dateformat(startDate?.date, rcDateTypeFormat)} ${dateformat(startDate?.date, rcTimeTypeFormat)}`,
      },
      to: {
        placeId: dPlaceId,
        countryCode: COUNTRYCODE,
        lobCountry: COUNTRYNAME,
        lobCity: dCityRegion ? dCityRegion : '',
        cityName: dCityName,
        locus: {
          city: locusDestinationCity,    // this will be locusCityCode
          type: locusDestinationType,
          name: locusDestinationName,
          country: locusDestinationCountry
        }
        // lng: null, // not sending as of now bcz we don't have lat lng
        // lat: null,
      },
      tripType: triptype?.name,
      journeyType: triptype?.rf,
      meta: {
        tg: 1011,
        gd: getGoDataNDeepLink(requiredData)?.goData,
        deeplink: getGoDataNDeepLink(requiredData)?.deepLink
      },
      lob: SEARCH_CONTEXT_LOB,
      funnelSource: getSubLobName(triptype?.rf),
      lobCategory: LOBCATEGORY
    }
  }
  if(triptype?.rf === "hr"){
    // for HR, we need to paas same source value in destination field
    searchDetails.searchContext['to'] = {
      placeId: sPlaceId,
      countryCode: COUNTRYCODE,
      lobCountry: COUNTRYNAME,
      lobCity: sCityRegion ? sCityRegion : '',
      cityName: sCityName,
      locus: {
        city: locusSourceCity,   // this will be locusCityCode
        type: locusSourceType,
        name: locusSourceName,
        country: locusSourceCountry
      }
    }
  }
  if(triptype?.name === ROUND_TRIP){
    searchDetails.searchContext['toDateTime'] = {
      ts: new Date(endDate?.date).getTime(),
      zone: TIMEZONE,
      timezone: TIMEZONE,
      str: `${dateformat(endDate?.date, rcDateTypeFormat)} ${dateformat(endDate?.date, rcTimeTypeFormat)}`,
    }
  }
  pushSearchesToApi({
    lobName: LOBNAME,
    searchDetails: searchDetails,
    onPushSuccess: (r) => {
     console.log('pushSearchesToApi success', r);
    },
    onPushFail: (e) => {
     console.log('pushSearchesToApi failed', e);
    }
  })
}

export const getSubtitleForAvailableCabs = (source, destination, trailingSentence = '') => {
  let subTitle = ''
  if (source && destination) {
    subTitle = `${source} to ${destination} ${trailingSentence}`
  } else if (source && !destination) {
    subTitle = `${source} ${trailingSentence}`
  } else if (!source && destination) {
    subTitle = `${destination} ${trailingSentence}`
  } else subTitle = ''

  return subTitle
}

export const getAllPackageIdsForRental = (packages = []) : string[] => {
  const packageIds : string[] = []

  packages.forEach(packageDetls => {
    if (packageDetls?.name) {
      packageIds.push(packageDetls?.name)
    }
  })

  if (packageIds?.length) {
    setter(HR_PACKAGE_IDS, packageIds)
  }
  
  return packageIds
}

export const setAllPackageIdsForRental = (packages = []) => {
  const packageIds : string[] = []

  packages.forEach(packageDetls => {
    if (packageDetls?.name) {
      packageIds.push(packageDetls?.name)
    }
  })

  if (packageIds?.length) {
    setter(HR_PACKAGE_IDS, packageIds)
  }
}

export const getTitleForFAQ = (tripType) => {
  switch(tripType) {
    case 'at':      return AT_FAQ
    case 'hr':      return HR_FAQ
    case 'ow-cab':  return ONE_WAY_CAB_FAQ
    default:        return DEFAULT_FAQ
  }
}

export const setCookie = (name, value, options = {}) => {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options?.expires) {
    cookieString += `; expires=${options?.expires.toUTCString()}`;
  }

  if (options?.path) {
    cookieString += `; path=${options?.path}`;
  }

  if (options?.domain) {
    cookieString += `; domain=${options?.domain}`;
  }

  if (options?.secure) {
    cookieString += `; secure`;
  }

  document.cookie = cookieString;
}

export const detectUserActivity = () => {
  window?.localStorage.removeItem('userActionDone');
  ['click'].forEach(evt =>
    document.body.addEventListener(evt, () => {
      if (window?.localStorage) {
        localStorage.setItem('userActionDone', 'true');
      }
    })
  );
};


